import React, {  useContext, useState, useCallback, useEffect  } from "react";
import {  Button, Form, Input, Popconfirm, Table, Select, Card, Col, Row, Divider, Modal, Space, Checkbox, Tooltip } from "antd";
import { MinusCircleOutlined, PlusOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { API_TXALERT, API_MERCHANT, API_RETAILER, API_SITE } from "../../config/config";
import GroupAccess from "../../helper/GroupAccess";
import htmlParser from "html-react-parser";

const MERCHANT_DATA_URL = API_MERCHANT + "/list";
const RETAILER_DATA_URL = API_RETAILER + "/list";
const SITE_DATA_URL = API_SITE + "/list";
const { confirm } = Modal;
const DATA_URL =  API_TXALERT + "/descriptor_enrollment/create";
const { Option } = Select;
const PROVIDER_OPTIONS = [
    { label: 'Ethoca', value: 'Ethoca' },
    { label: 'CDRN', value: 'CDRN' },
    { label: 'RDR', value: 'RDR' },
];
const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}> 
            <EditableContext.Provider value={form}>
                <tr disabled={true} {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    // products,
    copy,
    setCopy,
    rowDeleted,
    setRowDeleted,
    ...restProps
    }) => {
    const [editing, setEditing] = useState(false);
    const subform = useContext(EditableContext);
    const copyValue = () => {
        setEditing(!editing);
        subform.setFieldsValue(record);
        if(record.copied && copy){
            delete record.copied;
            handleSave(record);
            setCopy(false);
        }
    };

    const validateFormData = () => {
        if(rowDeleted){
            save();
            setRowDeleted(false);
        }

    };

    const save = async () => {
        // don't let one invalid field (e.g. empty rdr_ruleset) block saving the rest of the row
        const values = subform.getFieldsValue();
        // hidden fields (checkDisable's empty <div>) come back undefined - keep record's value instead
        const definedValues = Object.fromEntries(
            Object.entries(values).filter(([, v]) => v !== undefined)
        );
        handleSave({
            ...record,
            ...definedValues,
        });

        try {
            await subform.validateFields();
        } catch (errInfo) {
            // Per-row validation errors are surfaced via getRowErrorReason() (row
            // highlight + tooltip, and the aggregate check in onFinish on submit),
            // so nothing further to do here beyond letting the field show its
            // own inline validation message.
        }
    };

    useEffect(() => {
        if(copy){
            copyValue();
        }
    }, [copy]); // eslint-disable-line react-hooks/exhaustive-deps 
    //-- useCallback resolved warnings but cause lag on front end due to formValidation That's why eslint-disable is added.

    useEffect(() => {
        if(rowDeleted){
            validateFormData();
        }
    }, [rowDeleted]); // eslint-disable-line react-hooks/exhaustive-deps 
   // -- useCallback resolved warnings but cause lag on front end due to formValidation That's why eslint-disable is added.

    const onChange = async (list) => {
        try {
            await subform.validateFields(['provider']); // validate

            if (!list.includes('Ethoca') && !list.includes('CDRN')) {
                subform.setFieldsValue({ match_type: null });
            }

            if (!list.includes('RDR')) {
                subform.setFieldsValue({
                    visa_bin: null,
                    visa_caid: null,
                    visa_arn: null,
                    rdr_ruleset: null,
                });
            }

            // save() reads provider straight from the form (already validated above)
            save();
        } catch (e) {
            // validation failed 
        }
    };

    const checkDisable = () => {
            if((record.provider.includes('Ethoca')||record.provider.includes('CDRN')) && dataIndex === 'match_type'){
                return (<Select 
                    style={{ width: "100%" }} 
                    placeholder="Match Type"
                    onChange={save}
                >
                    <Option value="Starts with">Starts with</Option>
                    <Option value="Exact">Exact</Option>
                </Select> );
            } 
            
            if((record.provider.includes('RDR') || dataIndex === 'descriptor') && dataIndex !== 'match_type'){
                return <Input onPressEnter={save} onBlur={save} />
            }
            
            return <div></div>;
    };

    let childNode = children;
    if (editable) {
        childNode = 
            <Form.Item
                style={{margin: 0}}
                name={dataIndex === 'provider' ? [dataIndex]:dataIndex} 
                rules={ dataIndex === 'descriptor' ? [
                            {required: true, message: `${title} is required.`,}] :
                            dataIndex === 'provider' ? [
                                ({ getFieldValue }) => ({
                                    async validator(_, value) {
                                        try {
                                           if (!value || value.length === 0) {
                                                return Promise.reject(new Error(`${title} is required.`));
                                            }
                                            return Promise.resolve();
                                        } catch (error) {
                                            return Promise.reject(error.message);
                                        }
                                    },
                                })] : 
                            dataIndex === 'match_type' ? [
                                ({ getFieldValue }) => ({
                                    async validator(_, value) {
                                        try {
                                            if (!value && (record.provider.includes('Ethoca')||record.provider.includes('CDRN'))) {
                                                throw new Error("Match type is required.");
                                            } 
                                            return Promise.resolve();
                                        } catch (error) {
                                            return Promise.reject(error.message);
                                        }
                                    },
                                }),
                            ] :
                            (dataIndex === 'visa_bin') ? [
                                ({ getFieldValue }) => ({
                                    async validator(_, value) {
                                        try {
                                            if ( !value && !getFieldValue('visa_arn') && record.provider.includes('RDR')) {
                                                throw new Error("Visa BIN and CAID are required as a pair if Visa ARN is null.");
                                            }
                                            return Promise.resolve();
                                        } catch (error) {
                                            return Promise.reject(error.message);
                                        }
                                    },
                                }),
                            ] :
                            (dataIndex === 'visa_caid') ? [
                                ({ getFieldValue }) => ({
                                    async validator(_, value) {
                                        try {
                                            if ( !value && !getFieldValue('visa_arn') && record.provider.includes('RDR')) {
                                                throw new Error("Visa BIN and CAID are required as a pair if Visa ARN is null.");
                                            }
                                            return Promise.resolve();
                                        } catch (error) {
                                            return Promise.reject(error.message);
                                        }
                                    },
                                }),
                            ] :
                            dataIndex === 'visa_arn' ? [
                                ({ getFieldValue }) => ({
                                    async validator(_, value) {
                                        try {
                                            if (!value && record.provider.includes('RDR') && (!getFieldValue('visa_bin') && !getFieldValue('visa_caid')) ) {
                                                throw new Error("Visa ARN is required if Visa CAID or Visa BIN are null");
                                            } 
                                            return Promise.resolve();
                                        } catch (error) {
                                            return Promise.reject(error.message);
                                        }
                                    },
                                }),
                            ] 
                            : dataIndex === 'rdr_ruleset' ? [
                                ({ getFieldValue }) => ({
                                    async validator(_, value) {
                                        try {
                                            if (!value && record.provider.includes('RDR')) {
                                                throw new Error("RDR ruleset is required");
                                            } 
                                            return Promise.resolve();
                                        } catch (error) {
                                            return Promise.reject(error.message);
                                        }
                                    },
                                }),
                            ] 
                            : null
                        }
                >
                {dataIndex === 'provider' ? 
                    <Checkbox.Group
                        options={PROVIDER_OPTIONS}
                        onChange={onChange}
                    />
                : checkDisable() }
            </Form.Item>
            ;
    }

    return (<td {...restProps}>{childNode}</td>);
};

 const getRowErrorReason = (record) => {
        const reasons = [];

        if (!record.provider || record.provider.length === 0) {
            reasons.push('Provider is required');
        }

        if (!record.descriptor) {
            reasons.push('Descriptor is required');
        }

        if (
            (record.provider?.includes('Ethoca') || record.provider?.includes('CDRN')) &&
            !record.match_type
        ) {
            reasons.push('Match type is required for Ethoca / CDRN');
        }

        if (record.provider?.includes('RDR')) {
            if (!record.visa_arn && (!record.visa_bin || !record.visa_caid)) {
                reasons.push('Visa ARN or (Visa BIN + Visa CAID) is required for RDR');
            }
            if (!record.rdr_ruleset) {
                reasons.push('RDR ruleset is required');
            }
        }

        return reasons;
    };

const AddDescriptorEnrollmentForm = (props) => {
    const [count, setCount] = useState(1);
    const [dataSource, setDataSource] = useState([
        {
            key: 0,
            provider: [],
            descriptor: '',
            match_type: '',
            // mcc: '',
            visa_bin: '',
            visa_caid: '',
            visa_arn: '',
            rdr_ruleset: ''
        }
    ]);
    const { t } = props;
    const [form] = Form.useForm();
    const [formData, setFormData] = useState();
    const [merchantList, setMerchantList] = useState([]);
    const [retailerList, setRetailerList] = useState([]);
    const [siteList, setSiteList] = useState([]);
    const [inactiveChecked, setInactiveChecked] = useState(false);
    const [merchant, setMerchant] = useState([]);
    const [merchantName, setMerchantName] = useState('');
    const [retailer, setRetailer] = useState([]);
    const [retailerName, setRetailerName] = useState('');
    const [site, setSite] = useState([]);
    const [siteName, setSiteName] = useState('');
    const [rowDeleted, setRowDeleted] = useState(false);

    const [copy, setCopy] = useState(false);

    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
        setRowDeleted(true);
    };

    const handleCopy = async (key) => {
        try {
            // Get all latest form values
            await form.validateFields();

            // Find original row
            const originalRow = dataSource.filter((item) => item.key === key)[0];
        
            // Merge with form-edited values
            const updatedRow = {
                ...originalRow,
                copied:true     // to run copyValue()
            };

            // Insert copied row after original
            const newData = [
                ...dataSource.slice(0, key + 1),
                updatedRow,
                ...dataSource.slice(key + 1),
            ];

            // Re-key all rows for safety
            const finalData = newData.map((row, idx) => ({ ...row, key: idx }));

            setDataSource(finalData);
            setCount((prev) => prev + 1);
            setCopy(true);
        } catch (err) {
            console.error("Error during row copy:", err);
        }
    };

    const defaultColumns = [
        {
            title: t("tables.fields.provider"),
            dataIndex: 'provider',
            width: 160,
            fixed: "left",
            editable: true,
        },
        {
            title: t("tables.fields.descriptor"),
            dataIndex: 'descriptor',
            width: 150,
            editable: true,
        },
        {
            title: t("tables.fields.match_type"),
            dataIndex: 'match_type',
            width: 100,
            editable: true
        },
        //https://app.clickup.com/t/86d1n6684 - Hide MCC field in descriptor enrollment table
        // {
        //     title: t("tables.fields.mcc"),
        //     dataIndex: 'mcc',
        //     width: 80,
        //     editable: true
        // },
        {
            title: <Tooltip title={t("contents.descriptor_enrollment.tooltip.visa_bin_caid")}>{t("tables.fields.visa_bin")} <InfoCircleOutlined /></Tooltip>,
            dataIndex: 'visa_bin',
            width: 80,
            editable: true
        },
        {
            title: <Tooltip title={t("contents.descriptor_enrollment.tooltip.visa_bin_caid")}>{t("tables.fields.visa_caid")} <InfoCircleOutlined /></Tooltip>,
            dataIndex: 'visa_caid',
            width: 80,
            editable: true
        },
        {
            title: <Tooltip title={t("contents.descriptor_enrollment.tooltip.visa_arn")}>{t("tables.fields.visa_arn")} <InfoCircleOutlined /></Tooltip>,
            dataIndex: 'visa_arn',
            width: 110,
            editable: true
        },
        {
            title: <Tooltip title={
                            <div>
                                <div>{t("contents.descriptor_enrollment.tooltip.rule_set")}</div>
                                <ul style={{ paddingLeft: 16, margin: '4px 0' }}>
                                    <li>{t("contents.descriptor_enrollment.tooltip.rule_set_any_amount")}</li>
                                    <li>{t("contents.descriptor_enrollment.tooltip.rule_set_greater_than")}</li>
                                    <li>{t("contents.descriptor_enrollment.tooltip.rule_set_less_than")}</li>
                                </ul>
                            </div>
                        }>{t("tables.fields.rdr_ruleset")} <InfoCircleOutlined /></Tooltip>,
            dataIndex: 'rdr_ruleset',
            width: 120,
            editable: true,
            tooltip: t("contents.alerts.tooltip.outcome")
        },
        {
            title: t("tables.fields.action"),
            dataIndex: 'action',
            width: 150,
            fixed: "right",
            render: (_, record) =>
            dataSource.length >= 1 ? ( <div>
                <Popconfirm
                  title={t("contents.descriptor_enrollment.delete_confirm")} onConfirm={() => handleDelete(record.key)}>
                    <Button>{t("contents.descriptor_enrollment.delete")}</Button>
                </Popconfirm>
                <Button style={{marginLeft: 5,}} onClick={() => handleCopy(record.key)}>{t("contents.descriptor_enrollment.duplicate")}</Button>
                </div>
            ) : null,
        },
    ];

    const duplicateEntriesTableColumns = (showRows) => {
        const baseColumns = [
            {
            title: t("tables.fields.descriptor"),
            dataIndex: "descriptor",
            key: "descriptor",
            },
            {
            title: t("tables.fields.provider"),
            dataIndex: "provider",
            key: "provider",
            },
        ];

        if (showRows) {
            baseColumns.push({
            title: t("tables.fields.rows"),
            key: "rows",
            render: (_, record) => (
                <>Row {record.first} & Row {record.currentRow}</>
            ),
            });
        }
        return baseColumns;
    };

    const handleAdd = () => {
        const newData = {
            key: count,
            provider: [],
            descriptor: '',
            match_type: '',
            // mcc: '',
            visa_bin: '',
            visa_caid: '',
            visa_arn: '',
            rdr_ruleset: ''
        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
    };

    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return (col);
        }
        return ({
            ...col,
            onCell: (record) => ({
                title: col.title,
                editable: col.editable,
                dataIndex: col.dataIndex,
                record,
                handleSave,
                copy,
                setCopy,
                rowDeleted,
                setRowDeleted,
            }),
        });
    });

    const formValChange = (chgV, allV) => {
        setFormData(allV);
    };

    const confirmationGroupByAlertType = (alerttype) => {
        let group = dataSource.filter((obj) => obj.provider.includes(alerttype));
        if(group.length>0){
            return(
                <div key={alerttype}>
                    <h2>{alerttype}</h2>
                    <table key={alerttype} border="1" style={{width:"100%"}}>
                        <thead>
                            <tr>
                                <th>{t("tables.fields.descriptor")}</th>
                                {alerttype === 'Ethoca' || alerttype === 'CDRN' ? <th>{t("tables.fields.match_type")}</th> : null}
                                {/* {alerttype === 'RDR' ? <th>{t("tables.fields.mcc")}</th> : null} */}
                                {alerttype === 'RDR' ? <th>{t("tables.fields.visa_bin")}</th> : null}
                                {alerttype === 'RDR' ? <th>{t("tables.fields.visa_caid")}</th> : null}
                                {alerttype === 'RDR' ? <th>{t("tables.fields.visa_arn")}</th> : null}
                                {alerttype === 'RDR' ? <th>{t("tables.fields.rdr_ruleset")}</th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            {group.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.descriptor}</td>
                                        {alerttype === 'Ethoca' || alerttype === 'CDRN' ? <td>{item.match_type}</td> : null}
                                        {/* {alerttype === 'RDR' ? <td>{item.mcc}</td> : null} */}
                                        {alerttype === 'RDR' ? <td>{item.visa_bin}</td> : null}
                                        {alerttype === 'RDR' ? <td>{item.visa_caid}</td> : null}
                                        {alerttype === 'RDR' ? <td>{item.visa_arn}</td> : null}
                                        {alerttype === 'RDR' ? <td>{item.rdr_ruleset}</td> : null}
                                    </tr>
                                  ))}
                        </tbody>
                    </table>
                    <br />
                </div>
            )
        }
        return null;
    }

    const productsFromTable = [
        ...new Set(
            dataSource.flatMap(item => item.provider || [])
        )
    ];

    const onFinish = () => {
        // Validate every row up front (not just the last cell that happened to be
        // blurred) so the error message always names the specific missing field(s)
        // per row, instead of falling back to a generic "fill in required fields".
        const rowErrors = dataSource
            .map((record, index) => ({ row: index + 1, reasons:getRowErrorReason(record) }))
            .filter((r) => r.reasons.length > 0);

        if (rowErrors.length > 0) {
            Swal.fire({
                icon: "error",
                title: t("contents.descriptor_enrollment.confirm.title_error_save_data_table"),
                html: rowErrors
                    .map((r) => `<b>Row ${r.row}:</b> ${r.reasons.join(', ')}`)
                    .join('<br/>'),
                showConfirmButton: true,
            });
            return false;
        }
        if(dataSource){

            // Check for duplicate entry
            const seen = new Map();
            const duplicates = [];

            dataSource.forEach((item) => {
                const providers = item.provider || [];

                PROVIDER_OPTIONS.forEach((provider) => {
                    if (providers.includes(provider.value)) {
                        let key = [provider.value];
                        if(provider.value === 'RDR') {
                            key.push(item.descriptor, item.visa_bin, item.visa_caid, item.visa_arn, item.rdr_ruleset);
                        } else if(provider.value === 'Ethoca' || provider.value === 'CDRN') {
                            key.push(item.descriptor, item.match_type);
                        }
                        key = key.join('|');
                        if (seen.has(key)) {
                            duplicates.push({
                                descriptor: item.descriptor,
                                provider: provider.value,
                                currentRow: item.key + 1,
                                first: seen.get(key).key + 1
                            });
                        } else {
                            seen.set(key, item);
                        }
                    }
                })
            });

            if(duplicates.length) {
                Modal.error({
                    title: t("contents.descriptor_enrollment.duplicate_entries_found"),
                    width: 700,
                    content: (
                        <Table
                        columns={duplicateEntriesTableColumns(true)}
                        dataSource={duplicates}
                        rowKey={(record) =>
                            `${record.descriptor}-${record.provider}-${record.first}-${record.currentRow}`
                        }
                        pagination={false}
                        size="small"
                        />
                    ),
                });
                return;
            }
        }
        if (!productsFromTable || productsFromTable.length === 0) {
            Swal.fire({
                icon: "error",
                title: t("contents.descriptor_enrollment.confirm.title_empty_product"),
                text: t("contents.descriptor_enrollment.confirm.empty_product"),
                showConfirmButton: true,
            });
            return false;
        }
        let emails = [JSON.parse(localStorage.loggedUser)?.email];
        if (formData?.emails) {
            emails = emails.concat(formData.emails.map((item) => item.email));
        }

        const data = {
            mid: merchant.toString(),
            merchantname: merchantName,
            rid: retailer.toString(),
            retailername: retailerName,
            sid: site.toString(),
            sitename: siteName,
            email_cc_list: emails.toString(),
            products: productsFromTable.toString(),
            enrollment_items: dataSource
        };
        confirm({
            title: t("contents.descriptor_enrollment.confirm.title"),
            okButtonProps: {
                type: 'primary',
            },
            cancelButtonProps: {
                type: 'default',
            },
            content: (
                <div>
                    <p>
                        <br />
                        {t("contents.descriptor_enrollment.confirm.merchant")}: <strong>{merchantName}</strong>
                        <br />
                        {t("contents.descriptor_enrollment.confirm.retailer")}: <strong>{retailerName}</strong>
                        <br />
                        {t("contents.descriptor_enrollment.confirm.site")}: <strong>{siteName}</strong>
                        <br />
                        {t("contents.descriptor_enrollment.confirm.email_cc_list")}: <strong>{data.email_cc_list}</strong>
                        <br />
                        {t("contents.descriptor_enrollment.confirm.product")}:{" "} <strong>{productsFromTable.join(", ")}</strong>
                        <br />
                    </p>
                    {productsFromTable.map((item, index) => ( confirmationGroupByAlertType(item)))}
                    
                    
                </div>
            ),
            icon: <ExclamationCircleOutlined />,
            okText: t("contents.descriptor_enrollment.confirm.confirm_button"),
            cancelText: t("contents.descriptor_enrollment.confirm.cancel_button"),
            width: '80%',
            onOk() {
                return new Promise((resolve, reject) => {
                    axios
                        .post(DATA_URL, data,{ headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") }})
                        .then(({ data }) => {
                            if (data.status === "ok") {
                                let parsedInvalidItems = [];
                                try {
                                    parsedInvalidItems = data?.invalid_items
                                        ? JSON.parse(data.invalid_items)
                                        : [];
                                } catch (e) {
                                    parsedInvalidItems = [];
                                }

                                const normalizedItems = parsedInvalidItems.map((item, index) => ({
                                    ...item,
                                    provider: Array.isArray(item?.provider)
                                        ? item.provider.join(", ")
                                        : item?.provider,
                                    rowKey: index
                                }));

                                Modal.success({
                                    title: t("contents.descriptor_enrollment.enrollment_created"),
                                    content:
                                        normalizedItems.length > 0 ? (
                                        <>
                                            <div style={{ marginBottom: 8, fontWeight: 600, color: "red" }}>
                                                {t("contents.descriptor_enrollment.duplicate_entries_found")}
                                            </div>

                                            <Table
                                                columns={duplicateEntriesTableColumns(false)}
                                                dataSource={normalizedItems}
                                                rowKey="rowKey"
                                                pagination={false}
                                                size="small"
                                            />
                                        </>
                                        ) : null,
                                    width: 700,
                                    okText: "OK",
                                    onOk: () => window.location.reload(),
                                });
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("login.dialogs.catch"),
                                    text: data.error_msg.msg ? data.error_msg.msg + (data.error_msg.detail? ". Detail: "+data.error_msg.detail : "") : "",
                                    showConfirmButton: true,
                                });
                            }
                        })
                        .catch((error) => {
                            Swal.fire({
                                icon: "error",
                                title: t("login.dialogs.catch"),
                                text: error.response.data.error_msg.msg ? error.response.data.error_msg.msg + (error.response.data.error_msg.detail? ". Detail: "+error.response.data.error_msg.detail : "") : "",
                                showConfirmButton: true,
                            });
                        });
                });
            },
            onCancel() {
                return false;
            },
        });
    };

    const getMerchantList = useCallback(() => {
        axios
            .post(
                MERCHANT_DATA_URL,
                {getall:true},
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setMerchantList(data.list);
                if(data.list.length === 1 ){
                    setMerchant([data.list[0].mid]);
                    setMerchantName(htmlParser(data.list[0].name) + ` (mid: ` + data.list[0].mid + `)`);
                }
                else{
                    setMerchant([]);
                }
            })
            .catch(() => false);
    }, []);

    const getRetailerList = useCallback((mid_change) => {
        axios
            .post(
                RETAILER_DATA_URL,
                { mid: mid_change },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setRetailerList(data.list);
                if(data.list.length === 1 ){
                    setRetailer([data.list[0].rid]);
                    setRetailerName(htmlParser(data.list[0].name) + ` (rid: ` + data.list[0].rid + `)`);
                }else{
                    setRetailer([]);
                    setRetailerName('');
                }
            })
            .catch(() => false);
    }, []);

    const getSiteList = useCallback((mid_change, rid_change) => {
        axios
            .post(
                SITE_DATA_URL,
                { mid: mid_change, rid: rid_change },
                { headers: { Authorization: "Bearer " + Cookies.get("access_token"), Authuser: Cookies.get("authuser") } }
            )
            .then(async ({ data }) => {
                await setSiteList(data.list);   
                if(data.list.length === 1 ){
                    setSite([data.list[0].sid]);
                    setSiteName(htmlParser(data.list[0].name) + ` (sid: ` + data.list[0].sid + `)`);
                }else{
                    setSite([]);
                }
            })
            .catch(() => false);
    }, []);

    useEffect(() => {
        if (merchantList.length === 0) {           
            getMerchantList();
        }
        if (retailerList.length === 0) {
            getRetailerList();
        }
        if (siteList.length === 0) {
            getSiteList();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeMid = (mid_change,index) => {
        let mid_select = JSON.parse("[" + mid_change + "]");
        setMerchantName(index.children);
        setMerchant(mid_select);
    }

    const onChangeRid = (rid_change,index) => {
        let rid_select = JSON.parse("[" + rid_change + "]");
        setRetailer(rid_select);
        setRetailerName(index.children);
    }

    const onChangeSid = (sid_change,index) => {
        let sid_select = JSON.parse("[" + sid_change + "]");
        setSite(sid_select);
        setSiteName(index.children);
    }

    useEffect(() => {
        getRetailerList(merchant);
        form.setFieldsValue({merchant:merchant});
    }, [merchant]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getSiteList(merchant, retailer);
        form.setFieldsValue({retailer:retailer});
    }, [retailer]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        form.setFieldsValue({site:site});

        // Auto-resolve retailer from site if retailer was not explicitly selected
        if (site.length > 0 && !retailerName && retailerList.length > 0) {
            const selectedSite = siteList.find(s => s.sid === site[0]);
            if (selectedSite && selectedSite.rid) {
                const matchedRetailer = retailerList.find(r => r.rid === selectedSite.rid);
                if (matchedRetailer) {
                    setRetailer([matchedRetailer.rid]);
                    setRetailerName(htmlParser(matchedRetailer.name) + ` (rid: ` + matchedRetailer.rid + `)`);
                }
            }
        }
    }, [site]);// eslint-disable-line react-hooks/exhaustive-deps

    const onChangeInactive = (e) => {
        setInactiveChecked(e.target.checked);
    };

    const getMerchant = () => {
        if (inactiveChecked) {
            return merchantList.map((item) => (
                item.status === 'active' ?
                    <Option key={item.mid} value={item.mid}>
                        {htmlParser(item.name) + ` (mid: ` + item.mid + `)`}
                    </Option>
                    : <Option key={item.mid} value={item.mid} style={{ color: "#f5222d" }}>
                        {htmlParser(item.name) + ` (mid: ` + item.mid + `)`}
                    </Option>
            ))
        } else {
            return merchantList.map((item) => (
                item.status === 'active'
                    ?
                    <Option key={item.mid} value={item.mid}>
                        {htmlParser(item.name) + ` (mid: ` + item.mid + `)`}
                    </Option>
                    :
                    null
            ))
        }
    };

    const ErrorCell = ({ record, children }) => {
        const reasons = getRowErrorReason(record);
        if (!reasons.length) return children;

        return (
            <Tooltip
                title={
                    <div>
                        {reasons.map((r, i) => (
                            <div key={i}>• {r}</div>
                        ))}
                    </div>
                }
                placement="right"
            >
                <div className="cell-tooltip-wrapper">
                    {children}
                </div>
            </Tooltip>
        );
    };

    const mergedColumns = columns.map(col => ({
    ...col,
    render: (value, record, index) => (
        <ErrorCell record={record}>
            {col.render ? col.render(value, record, index) : value}
        </ErrorCell>
    )
}));

    return (
        <div>
            <style>
                {`
                    .row-has-error td {
                        background-color: #fff2f0 !important;
                    }

                    .row-has-error:hover td {
                        background-color: #ffe7e6 !important;
                    }

                    .cell-tooltip-wrapper {
                        width: 100%;
                        height: 100%;
                    }
                `}
            </style>
            <div className="search-wrap">
                <Card title={t("contents.descriptor_enrollment.title_form")} size="small">
                    <Form form={form} size="large" name="advanced_search" className="ant-advanced-search-form"  onFinish={onFinish} onValuesChange={formValChange}>
                        <Row gutter={[16, 16]}>
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                <Form.Item name="merchant"  rules={[{ required: true, message: t('required_field') }]}>
                                    <Select
                                        showSearch
                                        value={merchant}
                                        showArrow="true"
                                        style={{ width: "100%" }}
                                        optionFilterProp="children"
                                        onChange={(val,index) => onChangeMid(val,index)}
                                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                        filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        placeholder={t("contents.merchants.title")}
                                        dropdownRender={(menu) => GroupAccess("SYSADMIN") ? (
                                            <>
                                                {menu}

                                                <Divider
                                                    style={{
                                                        margin: '8px 0',
                                                    }}
                                                />
                                                <Space
                                                    style={{
                                                        padding: '0 8px 4px',
                                                    }}
                                                >
                                                    <Checkbox onChange={onChangeInactive}>Show Inactive?</Checkbox>
                                                </Space>
                                            </>
                                        ) : (
                                            <>
                                                {menu}
                                            </>
                                        )}
                                    >
                                        {merchantList
                                            ? getMerchant() 
                                            : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                <Form.Item name="retailer">
                                    <Select
                                        showSearch
                                        value={retailer}
                                        showArrow="true"
                                        style={{ width: "100%" }}
                                        optionFilterProp="children"
                                        onChange={(val,index) => onChangeRid(val,index)}
                                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                        filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        placeholder={t("contents.retailers.title")}>
                                        {retailerList
                                            ? retailerList.map((item) => (
                                                <Option key={item.rid} value={item.rid}>
                                                    {htmlParser(item.name) + ` (rid: ` + item.rid + `)`}
                                                </Option>
                                            ))
                                            : null}
                                    </Select>
                            </Form.Item>
                            </Col>
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                <Form.Item name="site"  rules={[{ required: true, message: t('required_field') }]}>
                                    <Select
                                        showSearch
                                        value={site}
                                        showArrow="true"    
                                        style={{ width: "100%" }}
                                        optionFilterProp="children"
                                        onChange={(val,index) => onChangeSid(val,index)}
                                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                        filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                                        placeholder={t("contents.sites.title")}>
                                        {siteList
                                            ? siteList.map((item) => (
                                                <Option key={item.sid} value={item.sid}>
                                                    {htmlParser(item.name) + ` (sid: ` + item.sid + `)`}
                                                </Option>
                                            ))
                                            : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                            <article className="ant-typography" style={{maxHeight: 400, overflowY: "auto"}}>
                                <div className="ant-typography well">
                                Upon submitting this form, a confirmation email will be sent to [{JSON.parse(localStorage.loggedUser)?.email}]. Should you wish to include additional recipients to the confirmation, add them below.
                                </div>
                            </article>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                <Form.List name="emails">
                                    {(fields, { add, remove }) => (
                                        <>
                                        {fields.map((field, index) => {
                                            return (
                                                <Row key={index}>
                                                    <Col span={3} style={{ textAlign: 'left' }}>
                                                        {index === 0 ? "Email: ": null}
                                                    </Col>
                                                    <Col span={20}>
                                                        <Form.Item {...field} name={[field.name, 'email']} 
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    type: "email",
                                                                    message: "Please enter a valid email address",
                                                                },
                                                            ]}
                                                            style={{ margin: '5px' }}>
                                                            <Input placeholder={t("tables.fields.email")} style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={1} style={{ alignContent:"center" }}>
                                                        <MinusCircleOutlined onClick={() => remove(field.name)} />
                                                    </Col>
                                                </Row>
                                            );
                                        })}
                                        
                                        <Form.Item>
                                            <Button
                                                type="dashed"
                                                onClick={() => add()}
                                                block
                                                icon={<PlusOutlined />}
                                            >
                                                Add additional recipient (optional)
                                            </Button>
                                        </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Col>
                        </Row>
                        <Divider orientation="left">{t("contents.descriptor_enrollment.configure_descriptors")}</Divider>
                        <Table
                            components={components}
                            rowClassName={(record) =>
                                getRowErrorReason(record).length ? 'row-has-error' : ''
                            }
                            onRow={(record) => {
                                const reasons = getRowErrorReason(record);
                                if (!reasons.length) return {};

                                return {
                                    title: reasons.join('\n'), // tooltip native
                                };
                            }}
                            bordered
                            dataSource={dataSource}
                            columns={mergedColumns}
                            scroll={{ x: 1500 }}
                            pagination={false}
                            footer={() => (
                                <div className="d-flex justify-content-end align-items-center">
                                    <Button
                                        onClick={handleAdd}
                                        type="primary"
                                    >
                                        {t("contents.descriptor_enrollment.add_descriptor")}
                                    </Button>
                                </div>)}

                        />
                        <Row type="flex" justify="center" align="center">
                            <Col>
                                <Form.Item style={{marginTop: 10}}>
                                    <Button type="primary" htmlType="submit" block >
                                    {t("contents.descriptor_enrollment.submit_form")}
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default AddDescriptorEnrollmentForm;
